/* globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../../styles/report.css';
import renderTemplate from '../../pdf/template';

class ReportView extends Component {
  static propTypes = {
    dataToPrint: PropTypes.shape({}),
    allChartData: PropTypes.shape({}),
    parameters: PropTypes.shape({})
  };

  render() {
    const { dataToPrint, allChartData, parameters } = this.props;
    return <div>{renderTemplate(dataToPrint, allChartData, parameters)}</div>;
  }
}

export default ReportView;
